module.exports = __webpack_public_path__ + "static/media/rich-lace-silver.bda37547.jpg";